'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SubMenuDrawer = _interopRequireDefault(require("./Header/SiteLinks/SubMenuDrawer"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class Link extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      originalStyle: this.props.style,
      style: this.props.style,
      subGroupLinks: {},
      id: ''
    };
  }
  handleEnter() {
    const style = Object.assign({}, this.state.style, this.props.hoverStyles);
    this.setState({
      style: style,
      hover: true
    });
  }

  // This resets the styles
  handleLeave() {
    this.setState({
      style: this.state.originalStyle,
      hover: false
    });
  }
  mobileLinkClick(e) {
    let parentNode = e.target.parentNode.id;
    let parentNodeId = document.getElementById(parentNode);
    let grandmaNode = parentNodeId.parentNode;
    if (e.target.id === 'link-selector' && grandmaNode.classList.contains('sub-menu')) {
      e.preventDefault();
    }
    parentNode = parentNode.toLowerCase().replace(/,/g, '');
    this.setState({
      id: parentNode
    });
    this.props.handleLinkGroups(parentNode);
  }
  render() {
    const rel = this.props.rel || null;
    const list = this.props.list ? this.props.list : null;
    let isOpen = false;
    let subObject = {};
    if (this.props.subLinks) {
      subObject = Object.assign({}, this.props.subLinks[this.state.id]);
      isOpen = this.props.subLinks[this.state.id] ? subObject.subOpen : false;
    }
    let aTag;
    // Render the href if we have one.
    if (this.props.href) {
      aTag = /*#__PURE__*/_react.default.createElement("a", {
        className: this.props.className,
        target: this.props.target,
        href: encodeURI(this.props.href),
        alt: this.props.alt,
        rel: rel,
        style: this.state.style,
        id: this.props.isSubGroupLink ? 'link-selector' : null
      }, this.props.children, ' ');
    } else {
      aTag = /*#__PURE__*/_react.default.createElement("a", {
        className: this.props.className,
        target: this.props.target,
        alt: this.props.alt,
        rel: rel,
        style: this.state.style,
        id: this.props.isSubGroupLink ? 'link-selector' : null
      }, this.props.children, ' ');
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      style: this.props.isSubGroupLink ? {
        display: 'block'
      } : {
        display: 'inline-block',
        'paddingLeft': '12px'
      },
      onMouseEnter: this.handleEnter.bind(this),
      onMouseLeave: this.handleLeave.bind(this),
      id: `${this.props.children}`,
      onClick: this.props.isMobile ? this.mobileLinkClick.bind(this) : null
    }, aTag, /*#__PURE__*/_react.default.createElement(_SubMenuDrawer.default, {
      isHovered: this.state.hover,
      list: list,
      isMobile: this.props.isMobile,
      linkClicked: this.state.isClicked,
      isOpen: isOpen,
      height: this.props.height,
      subMenuHeight: this.props.subMenuHeight
    }));
  }
}
exports.default = Link;
Link.defaultProps = {
  alt: ''
};
Link.propTypes = {
  style: _propTypes.default.object,
  className: _propTypes.default.string,
  href: _propTypes.default.string,
  alt: _propTypes.default.string,
  target: _propTypes.default.string,
  hoverStyles: _propTypes.default.object,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  subLinks: _propTypes.default.object,
  list: _propTypes.default.array,
  isSubGroupLink: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  subMenuHeight: _propTypes.default.object,
  handleLinkGroups: _propTypes.default.func,
  rel: _propTypes.default.string,
  height: _propTypes.default.number
};